(function () {

  var noop = (function () {
  })();

  var hasScrolled = false,
    scrollMaximumArticle = 0,
    scrollMaximumDocument = 0,
    scrollMaximumDepth = 0,
    lastReportedScrollMaximumArticle,
    lastReportedScrollMaximumDocument,
    lastReportedScrollDepth;

  /* Get element of the article body  */
  var article =
    document.querySelector('article .detail-body') ||
    document.querySelector('#content-wrapper') ||
    document.body;

  /* Get the total length of the article and the screen height of the article element.*/
  var articleLength = article.offsetHeight;
  var documentLength = (document.documentElement.scrollHeight - document.documentElement.offsetHeight);

  var hasEmbededContents = function () {
    return (0 !== article.querySelectorAll('[data-spy=embed]').length);
  }

  var _scrollReport = function () {

    /* Get the current scroll position */
    var scrollDepth =
      window.scrollY ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;

    /* Calculate the percentage of the article that has been scrolled */
    var scrollPercentArticle = Math.round((scrollDepth / articleLength) * 100) / 100;
    var scrollPercentDocument = Math.round((scrollDepth / documentLength) * 100) / 100

    /* If the scroll percentage is higher than the current maximum, set the new maximum */
    scrollMaximumArticle =
      scrollPercentArticle > scrollMaximumArticle
        ? scrollPercentArticle > 1
          ? 1
          : scrollPercentArticle
        : scrollMaximumArticle;

    /* If the scroll percentage is higher than the current maximum, set the new maximum */
    scrollMaximumDocument =
      scrollPercentDocument > scrollMaximumDocument
        ? scrollPercentDocument > 1
          ? 1
          : scrollPercentDocument
        : scrollMaximumDocument;

    scrollMaximumDepth = scrollDepth > scrollMaximumDepth ? scrollDepth : scrollMaximumDepth

    hasScrolled = false;
  };

  var _onScroll = function _onScroll() {
    if (!hasScrolled) {
      window.requestAnimationFrame(_scrollReport);
    }
    hasScrolled = true;
  };
  window.addEventListener('scroll', _onScroll, {
    passive: true
  });

  var report = function (event) {
    if (!PIANO.Utils.isEnabled()) {
      return;
    }

    // Push the payload to dataLayer, and only push valid time values
    if (
      (lastReportedScrollMaximumArticle !== scrollMaximumArticle) ||
      (lastReportedScrollMaximumDocument !== scrollMaximumDocument) ||
      (lastReportedScrollDepth !== scrollMaximumDepth)
    ) {
      var data = {
        'scroll_depth_article': scrollMaximumArticle,
        'scroll_depth_page': scrollMaximumDocument,
        'scroll_length_article_px': articleLength,
        'scroll_depth_page_px': scrollMaximumDepth,
        'has_embed': hasEmbededContents()
      };

      console.debug('Tracking Piano scrollDepth: sendEvent, page.scroll', event, data)

      _paq.push(['sendEvent', 'page.scroll', data]);

      lastReportedScrollMaximumArticle = scrollMaximumArticle;
      lastReportedScrollMaximumDocument = scrollMaximumDocument;
      lastReportedScrollDepth = scrollMaximumDepth;
    }

    if (event && 'beforeunload' === event.type) {
      console.debug('Tracking Piano scrollDepth: beforeunload');
      if (window.unloaded) {
        return;
      }

      scrollMaximumArticle = 0;
      lastReportedScrollMaximumArticle = noop;
      lastReportedScrollMaximumDocument = noop;
      window.unloaded = true;

      /* Remove the listeners from the window */
      window.removeEventListener('beforeunload', report);
    }

    if (event && 'visibilitychange' === event.type) {
      /* If the user changes the tab or minimizes the browser, set the tab as unloaded */
      if ('hidden' === document.visibilityState) {
        if (window.unloaded) {
          return;
        }
        window.unloaded = true;
        console.debug('Tracking Piano scrollDepth: visibility change hidden');
      }

      /* If the user changes back to the tab, set the tab as loaded */
      if ('visible' === document.visibilityState) {
        if (!window.unloaded) return;
        window.unloaded = false;
        console.debug('Tracking Piano scrollDepth: visibility change visible');

        /* If the user has been on the page for more than 30 minutes, push a new pageview event */
        if ((Date.now() - window.startTime) / 1000 > 1800) {
          console.debug('Tracking Piano scrollDepth: trigger `piano:pageview`');

          PIANO.Utils.trigger('pageview');

          window.startTime = Date.now();
        }
      }
    }
  };

  document.addEventListener('piano:beforeReplace', function () {
    console.debug('Tracking Piano scrollDepth: on beforeReplace');
    report({
      type: 'beforeReplace'
    });
  });
  document.addEventListener('piano:pushstate', function () {
    console.debug('Tracking Piano scrollDepth: on pushstate');

    scrollMaximumArticle = 0;
    lastReportedScrollMaximumArticle = noop;
    lastReportedScrollMaximumDocument = noop;
    hasScrolled = false;

    /* Get element of the article body  */
    article =
      document.querySelector('article .detail-body') ||
      document.querySelector('#content-wrapper') ||
      document.body;

    /* Get the total length of the article and the screen height of the article element.*/
    articleLength = article.offsetHeight;
    documentLength = document.documentElement.scrollHeight;
  });

  window.addEventListener('beforeunload', report);

  window.addEventListener('visibilitychange', report);

})();


